import { render } from "./Preview.vue?vue&type=template&id=1ff4de84&scoped=true&ts=true"
import script from "./Preview.vue?vue&type=script&lang=ts"
export * from "./Preview.vue?vue&type=script&lang=ts"

import "./Preview.vue?vue&type=style&index=0&id=1ff4de84&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff4de84"]])

export default __exports__